<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a :href="'/#/'">
            <i class="fa fa-home"></i>Home
          </a>
        </li>
        <li class="breadcrumb-item">
          <a v-if="['training material', 'manual'].includes(folderName)" :href="'/#/staticfolderlist/'+this.folderName">{{this.folderName}}</a>
          <a v-else :href="'/#/d1folderlist/'+this.folderName">{{this.folderName}}</a>
        </li>
        <li class="breadcrumb-item">
          <a :href="'/#/d2folderlist/'+this.folderName+'/'+this.dynamicFolder">{{this.dynamicFolder}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{this.selectFolder}}</li>
      </ol>
    </nav>
    <div class="card">
      <div class="card-header">
        <div class="card-title">{{this.selectFolder}}</div>
        <div class="card-tool">
          <select class="form-control" v-model="order" @change="sortByKey(files,'name',order)">
            <option v-bind:value="'DESC'">Title: Z - 0</option>
             <option v-bind:value="'ASC'">Title: 0 - Z</option>
          </select>
        </div>
      </div>
      <div class="card-body">
        <ul class="list-news">
          <li v-for="(file,index) in files.slice(startFiles,endFiles)" v-bind:key="index" >
            <a v-bind:href="file.webUrl" target="_blank">
              <div class="icon">
                <span class="fa-stack">
                  <!-- <i v-bind:class="getFileIcon(file)">{{file.name.split('.')[fileLength - 1].toUpperCase()}}</i> -->
                  <i v-bind:class="getFileIcon(file.name)">{{file.name.split('.')[file.name.split('.').length - 1].toUpperCase()}}</i>
                  <i class="fa fa-file-o fa-stack-1x"></i>
                </span>
              </div>
              <div class="con">
                <div class="title">{{file.name}}</div>
                <div class="text">{{$moment(file.createdDateTime).format("YYYY-MM-DD HH:mm:ss") }}</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <div class="card-footer">
        <div class="func-tool">
          <div class="pagination-num">
            {{currenPage}}/{{getTotalPage}}
            <span>Total:{{total}}</span>
          </div>
          <ul class="pagination justify-content-center">
            <li class="page-item">
              <a class="page-link" v-on:click="getLastPage(currenPage)">
                <i class="fa fa-angle-left"></i>
              </a>
            </li>
            <li class="page-item" v-for="(page,index) in getTotalPage" v-bind:key="index">
              <a class="page-link"  v-on:click="getPagination(index)">{{index+1}}</a>
            </li>
            <li class="page-item">
              <a class="page-link" v-on:click="getNextPage(currenPage)">
                <i class="fa fa-angle-right"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'FolderList',
  data: () => ({
    startFiles: 0,
    endFiles: 30,
    numberPerPage: 30,
    currenPage: 1,
    order: 'ASC',
    total: 0,
    folderName: '',
    dynamicFolder: '',
    selectFolder: '',
    fileLength: 0,
    files: []
  }),
  created () {
    this.folderName = this.$route.params.name
    this.dynamicFolder = this.$route.params.category
    this.selectFolder = this.$route.params.select
    switch (this.folderName) {
      case 'Meal':
      case 'Wine':
      case 'Galley Loading':
        this.getList(localStorage.getItem('access_token'), this.GLOBAL.sharepoint['pilotportalsite_id'], this.GLOBAL.pilotportal['mealwine_list'], this.folderName)
          .then(resp => {
            this.files = resp.data.value
            this.total = resp.data.value.length
            this.sortByKey(this.files, 'name', 'DESC')
          })
          .catch(err => {
            console.log('err', err)
          })
        break
      default:
        this.getPilotD2File(localStorage.getItem('access_token'), this.folderName, this.dynamicFolder, this.selectFolder)
          .then(resp => {
            this.files = resp.data.value
            this.total = resp.data.value.length
            this.sortByKey(this.files, 'name', 'ASC')
          })
          .catch(err => {
            console.log('err', err)
          })
        break
    }
  },
  methods: {
    getFileImg (fileobj) {
      switch (fileobj.name.split('.')[1]) {
        case 'docx':
          return 'img/bg_doc.jpg'
        case 'pptx':
          return 'img/bg_ppt.jpg'
        case 'xlsx':
          return 'img/bg_xls.jpg'
        case 'pdf':
          return 'img/bg_pdf.jpg'
        case 'm4a':
        case 'aac':
          return 'img/bg_media.jpg'
        case 'png':
        case 'jpg':
          return 'img/bg_img.jpg'
        default:
          return 'img/bg_file.jpg'
      }
    },
    getFileIcon (filename) {
      var temp = filename.split('.')[filename.split('.').length - 1].toLowerCase()
      switch (temp) {
        case 'pptx':case 'ppt':
          return 'fa fa-stack-1x text-xs bg-dark'
        case 'pdf':
          return 'fa fa-stack-1x text-xs bg-danger'
        case 'jpg':case 'jpeg':case 'png':case 'gif':
          return 'fa fa-stack-1x text-xs bg-success'
        case 'mp4':case 'wmv':case 'mov':
          return 'fa fa-stack-1x text-xs'
        default:
          return 'fa fa-stack-1x text-xs d-none'
      }
    },
    getPagination (page) {
      this.currenPage = page + 1
      this.startFiles = page * this.numberPerPage
      this.endFiles = (page + 1) * this.numberPerPage
    },
    getLastPage (page) {
      if (page > 1) {
        this.currenPage = page - 1
        this.startFiles = (page - 2) * this.numberPerPage + 1
        this.endFiles = (page - 1) * this.numberPerPage
      }
    },
    getNextPage (page) {
      if (page < this.getTotalPage) {
        this.currenPage = page + 1
        this.startFiles = page * this.numberPerPage
        this.endFiles = (page + 1) * this.numberPerPage
      }
    },
    sortByKey (array, key, order) {
      return array.sort((a, b) => {
        var x = a[key]
        var y = b[key]
        if (order === 'DESC') {
          return ((x < y) ? 1 : ((x > y) ? -1 : 0))
        } else if (order === 'ASC') {
          return ((x < y) ? -1 : ((x > y) ? 1 : 0))
        }
      })
    }
  },
  computed: {
    getTotalPage () {
      return Math.ceil(this.files.length / this.numberPerPage) ? Math.ceil(this.files.length / this.numberPerPage) : 1
    }
  }
}
</script>
